import Skeleton from './Skeleton';
export default Skeleton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/skeleton/index.js
// module id = 478
// module chunks = 0